module.exports = __webpack_public_path__ + "media/images/top/common/img_feature02-ce77788241f59676e9c6081cb18c0fa9.png";